import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import _pt from "prop-types";
var _excluded = ["id", "className", "mandatory", "onClose", "isOpen", "takeover", "size", "children", "returnFocus", "closeButtonProps", "compact", "isVerticallyCentered"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { useMotionPref } from '@lmig/lmds-react-loading-spinner/dist/useMotionPref';
import { useKeyPress } from '@lmig/lmds-react-hooks';
import FocusLock from 'react-focus-lock';
import { CSSTransition } from 'react-transition-group';
import { ModalClose } from './components/ModalClose';
import { ModalContainer } from './components/ModalContainer';
import { Overlay } from './components/Overlay';
import { ModalContext } from './context';
import "./modal.css";
import { PortalContainer } from './components/PortalContainer';
import { useCheckChild } from './hooks/useCheckChild';
import { ModalHeader } from './components/ModalHeader';
import { useCurrentBreakpoint } from './hooks/useCurrentBreakpoint';
export var SIZES = ['small', 'medium', 'large'];
export var BREAKPOINTS = ['base', 'sm', 'md', 'lg', 'xl'];
var instance = 0;

/**
 * Main content of the Modal.
 */
export var Modal = function Modal(_ref) {
  var id = _ref.id,
    className = _ref.className,
    _ref$mandatory = _ref.mandatory,
    mandatory = _ref$mandatory === void 0 ? false : _ref$mandatory,
    onClose = _ref.onClose,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    _ref$takeover = _ref.takeover,
    takeover = _ref$takeover === void 0 ? [] : _ref$takeover,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    children = _ref.children,
    _ref$returnFocus = _ref.returnFocus,
    returnFocus = _ref$returnFocus === void 0 ? true : _ref$returnFocus,
    closeButtonProps = _ref.closeButtonProps,
    _ref$compact = _ref.compact,
    compact = _ref$compact === void 0 ? false : _ref$compact,
    _ref$isVerticallyCent = _ref.isVerticallyCentered,
    isVerticallyCentered = _ref$isVerticallyCent === void 0 ? false : _ref$isVerticallyCent,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    modalTitleID = _useState2[0],
    setModalTitleID = _useState2[1];
  var modalContainerRef = useRef(null);
  var _useMotionPref = useMotionPref(),
    motionPref = _useMotionPref.motionPref;
  var isHeaderPresent = useCheckChild(children, ModalHeader);
  useKeyPress('Escape', !mandatory ? onClose : null);
  var _useState3 = useState(function () {
      instance++;
      return id || "lmig-Modal-".concat(instance);
    }),
    _useState4 = _slicedToArray(_useState3, 1),
    uniqueId = _useState4[0];
  var currentBP = useCurrentBreakpoint();
  var isAtTakeover = takeover.includes(currentBP);

  /**
   * Hook that applies class to document.body to not allow scrolling on body while modal is open.
   */
  useEffect(function () {
    if (!isOpen || !document) return undefined;
    document.body.classList.add('lmig-Modal--freezeScroll');
    return function () {
      document.body.classList.remove('lmig-Modal--freezeScroll');
    };
  }, [isOpen]);
  var takeoverClasses = takeover.map(function (breakpoint) {
    return "lmig-Modal--takeover-".concat(breakpoint);
  });
  var classNames = classnames('lmig-Modal', "lmig-Modal--size-".concat(size), className, takeoverClasses, {
    'lmig-Modal--open': isOpen
  }, {
    'lmig-Modal--hasMotion': !motionPref
  }, {
    'lmig-Modal--headerSpacing-48': isHeaderPresent
  }, {
    'lmig-Modal--headerSpacing-32': !isHeaderPresent
  }, {
    'lmig-Modal--takeover': isAtTakeover
  }, {
    'lmig-Modal--compact': compact
  }, {
    'lmig-Modal--vertically-centered': !isAtTakeover && isVerticallyCentered
  });
  var handleModalFocus = function handleModalFocus() {
    modalContainerRef.current.focus();
  };
  return /*#__PURE__*/React.createElement(CSSTransition, {
    "in": isOpen,
    unmountOnExit: true,
    timeout: 50,
    onEntered: handleModalFocus
  }, function (transitionState) {
    return /*#__PURE__*/React.createElement(PortalContainer, null, /*#__PURE__*/React.createElement(FocusLock, {
      returnFocus: returnFocus,
      autoFocus: isOpen
    }, /*#__PURE__*/React.createElement("div", _extends({
      id: uniqueId,
      "aria-modal": "true",
      "aria-hidden": !isOpen,
      className: classnames(classNames, "lmig-Modal--".concat(transitionState)),
      tabIndex: -1,
      role: "dialog"
    }, modalTitleID !== '' && {
      'aria-labelledby': modalTitleID
    }, otherProps), /*#__PURE__*/React.createElement(ModalContext.Provider, {
      value: {
        isOpen: isOpen,
        modalTitleID: modalTitleID,
        setModalTitleID: setModalTitleID
      }
    }, /*#__PURE__*/React.createElement(ModalContainer, {
      innerRef: modalContainerRef
    }, children, !mandatory && /*#__PURE__*/React.createElement(ModalClose, _extends({}, closeButtonProps, {
      onClick: onClose
    }))), !isAtTakeover && /*#__PURE__*/React.createElement(Overlay, {
      onClick: mandatory ? null : onClose
    })))));
  });
};
Modal.propTypes = {
  /** Add an optional ID to this element: `<div class="lmig-Modal">`. If none is provided, a unique ID will be generated. */id: _pt.string,
  /** Add custom classes to this element: `<div class="lmig-Modal">`. */className: _pt.string,
  /** If true, this will remove the close icon button and disable background click to close the modal  */mandatory: _pt.bool,
  /** Function to fire when user clicks on the close icon button or background */onClose: _pt.func,
  /** an array of breakpoint names when the modal should switch to full screen. Options: ['base', 'sm', 'md', 'lg', 'xl'] */takeover: _pt.arrayOf(_pt.string),
  /** Controls whether the modal is open by default. */isOpen: _pt.bool,
  /** Exposes `ReactFocusLockProps'` `returnFocus` prop.
     * If this prop is true, the focus will be returned to its previous location when the modal is closed.
     */
  returnFocus: _pt.bool,
  /** Size of the modal. Sizes available are: small, medium, large */size: _pt.oneOf(['small', 'medium', 'large']),
  /** Content within the Modal is rendered in this element: `<section class="lmig-Modal-container">` */children: _pt.node.isRequired,
  /** Set compact spacing within Modal
     * @default false
     */
  compact: _pt.bool,
  /** Set Modal to be vertically centered within the page. This will be ignored if the Modal is at a takeover breakpoint.
     * @default false
     */
  isVerticallyCentered: _pt.bool
};